import { BillableServiceItem } from "@/Common/Models/BillableServiceItem";

class BillableServiceDropdownItem {
    public Service: BillableServiceItem;
    public Active: boolean;

    constructor() {
        this.Service = new BillableServiceItem();
        this.Active = true;
    }

    public GetServiceName(): string {
        if (sessionStore.userLanguageCode === "fr")
            return this.Service.Number + " - " + this.Service.NameFr;
        else if (sessionStore.userLanguageCode.toLowerCase().replace("-", "") === "esmx")
            return this.Service.Number + " - " + this.Service.NameEs;
        else
            return this.Service.Number + " - " + this.Service.NameEn;
    }
}

export { BillableServiceDropdownItem };
